import { BreadcrumbInfoItems } from 'src/components/SimpleBreadcrumb';

export const applicationBreadcrumb: BreadcrumbInfoItems = [
  {
    label: 'APLICATIVO',
  },
];
